const styles = {
  buttonChip: {
    minWidth: '1.2rem',
    height: '1.2rem',
    marginTop: '.15rem',
    marginLeft: '.5rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'var(--neutral-white)',
    borderRadius: '50%',
    fontSize: '.75rem',
    color: 'var(--primary-dark)',
  },
}

export default styles
